import { ReactElement } from 'react'
import { commentColorOptions } from '@constants'
import { MenuItem, Select, SelectProps, Stack, Typography } from '@mui/material'

interface CommentColorSelectProps {
  value: string
  onChange: (key: string) => void
  size?: SelectProps['size']
  fullWidth?: boolean
  minWidth?: number
}

const CommentColorSelect = ({
  value,
  onChange,
  size = 'small',
  fullWidth = false,
  minWidth = 120,
}: CommentColorSelectProps): ReactElement => {
  return (
    <Select
      value={value}
      onChange={event => onChange(event.target.value)}
      size={size}
      fullWidth={fullWidth}
      sx={{ minWidth }}
    >
      {commentColorOptions.map(option => (
        <MenuItem key={option.key} value={option.key}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography
              sx={{
                px: 1,
                py: 0.25,
                borderRadius: '4px',
                backgroundColor: option.backgroundColor,
                color: option.color,
                border: '1px solid #ccc',
                minWidth: 30,
                textAlign: 'center',
              }}
            >
              {option.label}
            </Typography>
          </Stack>
        </MenuItem>
      ))}
    </Select>
  )
}

export default CommentColorSelect
